import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/layout/PageHeader';
import { PricingTiers } from '../components/pricing/PricingTiers';
import { CtaBand } from '../components/ui/CtaBand';
import { FaqList } from '../components/ui/FaqList';
import { SectionHeading } from '../components/ui/SectionHeading';
import { faqs } from '../data/site';
import { programs } from '../data/programs';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
export function Pricing() {
  useDocumentMeta({
    title: 'Pricing — Republic',
    description: 'Membership from $39/mo, medication priced separately and published up front. Your rate is held for twelve months.'
  });
  return <main data-id="element-427" data-mp="3cazqsgbm4xay">
      <PageHeader eyebrow="Pricing" title="Published rates, held for twelve months." intro="Clinical care and medication are priced separately so you can see exactly what you are paying for. No dispensing fees, no per-message charges." data-id="element-428" data-mp="3cb81q2o6dsji" />

      <section className="bg-cream" data-id="element-429" data-mp="1elf2n0rn9qrf">
        <div className="mx-auto max-w-shell px-6 pb-20 pt-8 md:px-8 md:pb-28" data-id="element-430" data-mp="1ekdh22d05lvg">
          <PricingTiers data-id="element-431" data-mp="1jm2qxeohnthy" />
        </div>
      </section>

      <section className="bg-cream-light" data-id="element-432" data-mp="14nsa3bhfa0oz">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-433" data-mp="14otx8ebpqdn2">
          <SectionHeading eyebrow="Program rates" title="What each program costs on top of membership." intro="Medication pricing reflects what the pharmacy charges plus a fixed handling rate we publish. It does not change with your dose." data-id="element-434" data-mp="19mbwfczxhehv" />
          <table className="mt-12 w-full text-left" data-id="element-435" data-mp="1nmwgechkxgcy">
            <caption className="sr-only" data-id="element-436" data-mp="1nm3g9ud4lp3s">Monthly medication cost by Republic program</caption>
            <thead data-id="element-437" data-mp="1sk50iimafugu">
              <tr className="rule text-[0.6875rem] uppercase tracking-label text-ink-muted" data-id="element-438" data-mp="1sjmw2yph29xu">
                <th scope="col" className="py-3 font-normal" data-id="element-439" data-mp="2g9z9gp3hkyvt">
                  Program
                </th>
                <th scope="col" className="hidden py-3 font-normal sm:table-cell" data-id="element-440" data-mp="2l43hlbohncyh">
                  Category
                </th>
                <th scope="col" className="py-3 text-right font-normal" data-id="element-441" data-mp="2pyee6hfxedh4">
                  From
                </th>
              </tr>
            </thead>
            <tbody data-id="element-442" data-mp="2lvhs2gr6fz8f">
              {programs.map(program => <tr key={program.slug} className="rule" data-id="element-443" data-mp="2gx6h22p5biom">
                  <th scope="row" className="py-5 pr-6 font-serif text-xl font-normal text-ink md:text-2xl" data-id="element-444" data-mp="2bz4xlgnt5hcm">
                    {program.name}
                  </th>
                  <td className="hidden py-5 text-sm text-ink-muted sm:table-cell" data-id="element-445" data-mp="276v9m6696rcz">
                    {program.category}
                  </td>
                  <td className="py-5 text-right font-serif text-xl text-ink md:text-2xl" data-id="element-446" data-mp="1y806x42f3zef">
                    ${program.priceFrom}
                    <span className="ml-2 font-sans text-xs text-ink-muted" data-id="element-447" data-mp="1t7c4lm8qnw4w">/mo</span>
                  </td>
                </tr>)}
            </tbody>
          </table>
          <p className="mt-8 max-w-2xl text-sm leading-relaxed text-ink-muted" data-id="element-448" data-mp="3sb6xar37ijw">
            Prices shown are the starting monthly cost for the medication component and assume an
            active membership. HSA and FSA documentation is provided for every charge.
          </p>
          <Link to="/shop" className="mt-6 inline-flex border-b border-brick pb-1 text-sm text-brick transition-colors duration-150 ease-republic hover:border-ink hover:text-ink" data-id="element-449" data-mp="hr14sslqdm9b">
            See per-medication pricing in the pharmacy
          </Link>
        </div>
      </section>

      <section className="bg-cream" data-id="element-450" data-mp="3q6kwvoao0yms">
        <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-451" data-mp="3q5jknghwy63h">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-452" data-mp="3uyuqpfewiiuc">
            <SectionHeading eyebrow="Questions" title="Answered plainly." data-id="element-453" data-mp="2yggchpmwoblk" />
            <FaqList items={faqs} data-id="element-454" data-mp="2ye3ujch5e18i" />
          </div>
        </div>
      </section>

      <CtaBand data-id="element-455" data-mp="32ffep2h95u9b" />
    </main>;
}